<template>
    <!-- <NuxtLink :to="localePath(`/texty/${knihaKod}/${temaKod}`)">
        <span class="uapz05" v-html="formattedHtml" />
    </NuxtLink> -->
    <span v-if="html.includes('(')">(</span
    ><template
        v-for="(code, i) in parts"
        :key="i"
        >{{ i === 0 ? "" : " / "
        }}<NuxtLink
            v-tooltip.bottom="footnoteContent(code)"
            :to="getLinkUrl(code)"
            class="uapz06 cursor-pointer"
        >
            {{ code }}
        </NuxtLink></template
    ><span v-if="html.includes(')')">)</span>
</template>

<script lang="ts" setup>
const localePath = useLocalePath()
const store = useMainStore()

const props = defineProps<{
    html: string
}>()

const formattedHtml = props.html.replace(
    /<span class="uapz06">\s?\(?(.*?)\)? ?<\/span>/g,
    "$1"
)

const parts = ref<string[]>([])
const codes = formattedHtml?.split(/ ?(\/|,) ?/g)
codes?.forEach(code => {
    if (code === "/" || code === ",") return
    parts.value.push(code)
})

const getLinkUrl = (code: string) => {
    if (code.includes("i")) {
        const skupinaKod = code
            .split(".")
            .slice(0, -1)
            .join(".")
            .replace("i", "m")
        return localePath(
            `/cisla/katalog-indikatoru-a-metrik/${skupinaKod}?indikator=${code}`
        )
    }
    const metrikaTooltip = store.tooltips.metriky.find(
        metrika => metrika.KOD === code
    )
    if (metrikaTooltip && metrikaTooltip.KATALOG === "KMEČ") {
        return localePath(`/cisla/katalog-mestskych-casti/metriky/${code}`)
    }
    const skupinaKod =
        code.split(".").length === 5
            ? code.split(".").slice(0, -1).join(".")
            : code
    return localePath(`/cisla/katalog-indikatoru-a-metrik/${skupinaKod}`)
}

const footnoteContent = (code: string) => {
    if (code.includes("i")) {
        const item = store.tooltips.indikatory.find(
            indikator => indikator.KOD === code
        )
        return `Indikátor ${code}: ${item?.NAZEV}`
    }
    if (code.split(".").length === 5) {
        const item = store.tooltips.metriky.find(
            metrika => metrika.KOD === code
        )
        return `Metrika ${code}: ${item?.NAZEV}`
    }
    const item = store.tooltips.skupinyMetrik.find(
        skupina => skupina.KOD === code
    )
    return `Skupina metrik ${code}: ${item?.NAZEV}`
}
</script>

<style scoped></style>
